import React from 'react';
import { IBestDataset } from '../../../../../types/analytics';
import { IScatterTableApiPayload } from '../../../../../types/chart';
import { MarkerItem } from '../../../../../types/home';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { IEnrichedMetadata } from '../../../../../types/metadata';
import ScatterTable from '../Plot/ScatterTable/ScatterTable';

interface ScatterTableBoxProps {
  activePlotAnalytics: string | null;
  enrichedMetadata: IEnrichedMetadata[];
  previewDatasetId: string;
  coordinates: number[];
  categoryDataset: IBestDataset[];
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  isOfflineDataset: boolean;
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
  scatterTableData: any[];
  dateRange: any;
  updatingScatterTable: boolean;
  onUpdateScatterTable: (payload: IScatterTableApiPayload) => void;
  onDatasetChange: (value: string) => void;
  scatterTableError: string;
  scatterTableLinks: string[];
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (update: Partial<IAnalytcisUserInput>) => void;
  gridCellSize: string;
  waterDepth: string;
  onChangeActiveKey: (item: any, key?: string) => void;
  pointOption: { label: string; value: string }[];
  point?: MarkerItem;
}

const ScatterTableBox: React.FC<ScatterTableBoxProps> = ({
  activePlotAnalytics,
  enrichedMetadata,
  previewDatasetId,
  coordinates,
  categoryDataset,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  scatterTableData,
  dateRange,
  updatingScatterTable,
  onUpdateScatterTable,
  onDatasetChange,
  scatterTableError,
  scatterTableLinks,
  pointName,
  userInput,
  updateUserInput,
  gridCellSize,
  waterDepth,
  onChangeActiveKey,
  pointOption,
  point,
  isOfflineDataset,
}) => {
  if (activePlotAnalytics !== 'Scatter Table') {
    return null;
  }

  return (
    <ScatterTable
      previewDatasetId={previewDatasetId}
      coordinates={coordinates}
      categoryDataset={categoryDataset}
      enrichedMetadata={enrichedMetadata}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      data={scatterTableData}
      dateRange={dateRange}
      updating={updatingScatterTable}
      onUpdate={onUpdateScatterTable}
      onDatasetChange={onDatasetChange}
      error={scatterTableError}
      scatterTableLinks={scatterTableLinks}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      gridCellSize={gridCellSize}
      waterDepth={waterDepth}
      onChangeActiveKey={onChangeActiveKey}
      pointOption={pointOption}
      point={point}
      isOfflineDataset={isOfflineDataset}
    />
  );
};

export default ScatterTableBox;
